const SUPPORTED_URL_PROTOCOLS = new Set([
    'http:',
    'https:',
    'mailto:',
    'sms:',
    'tel:'
]);
const sanitizeUrl = (url)=>{
    if (!/^[a-z][a-z0-9+.-]*:/i.test(url)) return url;
    try {
        const parsedUrl = new URL(url);
        if (!SUPPORTED_URL_PROTOCOLS.has(parsedUrl.protocol)) return 'about:blank';
    } catch (unused) {
        return 'about:blank';
    }
    return url;
};
export { SUPPORTED_URL_PROTOCOLS, sanitizeUrl };
